<nb-card>
  <nb-card-body>
    <div class="row top-panel">
      <div class="col-12 col-md-5 text-center">
        <div class="date-selector text-center">
          <button class="date-today" nbButton (click)="toDay()">Today</button>
          <button class="date-prev" nbButton (click)="prevDate()">
            <nb-icon icon="chevron-left-outline"></nb-icon>
          </button>
          <input
            id="inputDay"
            [nbDatepicker]="datepicker"
            nbInput
            type="button"
            [(ngModel)]="pickerDate"
            (ngModelChange)="changeDate($event)"
          />
          <nb-datepicker #datepicker format="EE, MMM dd, yyyy"></nb-datepicker>
          <button class="date-next" nbButton (click)="nextDate()">
            <nb-icon icon="chevron-right-outline"></nb-icon>
          </button>
        </div>
      </div>
      <div class="col-12 col-md-7 right-action-panel">
        <button nbButton (click)="addEmployee()" status="success">
          <nb-icon icon="plus-outline"></nb-icon>Add employee
        </button>
        <!--        <button nbButton (click)="onReorderEmployee()" status="warning">-->
        <!--          <app-icon icon="sort" pack="fas"></app-icon>Reorder-->
        <!--        </button>-->
        <!--        <button nbButton (click)="onRemoveEmployee()" status="danger">-->
        <!--          <nb-icon icon="trash-outline"></nb-icon>Remove employee-->
        <!--        </button>-->

        <button nbButton (click)="onTipSeparatorClick()" status="info">
          <nb-icon icon="code"></nb-icon>Distribute tips
        </button>
        <button nbButton (click)="onRequestInformation()" status="warning">
          <nb-icon icon="alert-circle-outline"></nb-icon>Request Information
        </button>
        <button
          nbButton
          status="success"
          [nbContextMenu]="menuEmployee"
          nbContextMenuTag="menu-employees"
          nbContextMenuPlacement="bottom"
          nbContextMenuTrigger="hover"
        >
          <!--          <nb-icon icon="more-horizontal-outline"></nb-icon>-->
          More ...
        </button>
      </div>
    </div>
    <nb-card-body class="j-container">
      <div class="j-row">
        <div class="j-col" *ngFor="let employee of dataSource?.employees">
          <app-turn-column [data]="employee" (onDataChange)="onEmployeeDataChange($event)"></app-turn-column>
        </div>
      </div>
    </nb-card-body>
    <ng-container *ngIf="dataSource?.employees?.length">
      <hr />
      <app-turn-order [data]="dataSource.employees"></app-turn-order>
    </ng-container>
  </nb-card-body>
</nb-card>
<div class="container">
  <div class="row">
    <!--    turn summary-->
    <div class="col-12 col-sm-4 col-lg-3">
      <nb-card accent="primary">
        <nb-card-header>
          <!--        <nb-icon icon="info-outline" status="info"></nb-icon>-->
          Turn summary</nb-card-header
        >
        <nb-card-body>
          <ul>
            <li>
              <div class="title">Total amount:</div>
              <strong>${{ summary.amt | AmountPipe }}</strong>
            </li>
            <li class="li--no-symbol">
              <div class="title">
                In cash:
                <div class="in-cash-icon"></div>
              </div>
              <strong>${{ summary.cash | AmountPipe }}</strong> ({{ summary.cashPercent }}%)
            </li>
            <li>
              <div class="title">
                Redeem amount:
                <nb-icon icon="gift-outline" status="info"></nb-icon>
              </div>
              <strong>${{ summary.redeemAmt | AmountPipe }}</strong>
            </li>
            <li>
              <div class="title">Employees:</div>
              <strong>{{ dataSource?.employees?.length || 0 }}</strong>
            </li>
            <li>
              <div class="title">Turns:</div>
              <strong>{{ summary.turn }}</strong>
            </li>
          </ul>
        </nb-card-body>
      </nb-card>
    </div>
    <!--    gift card summary-->
    <div *ngIf="dataSource.summary?.giftCard?.totalSold" class="col-12 col-sm-4 col-lg-3">
      <nb-card accent="primary">
        <nb-card-header>
          <!--        <nb-icon icon="info-outline" status="info"></nb-icon>-->
          Gift card summary</nb-card-header
        >
        <nb-card-body>
          <!--          <div class="summary-group-title"><nb-icon icon="gift-outline"></nb-icon> Gift card</div>-->
          <ul>
            <li>
              <div class="title">Sold:</div>
              <strong>{{ dataSource?.summary?.giftCard?.totalSold || 0 }}</strong>
            </li>
            <li>
              <div class="title">Amount:</div>
              <strong>${{ dataSource?.summary?.giftCard?.totalAmt || 0 | AmountPipe }}</strong>
            </li>
            <li>
              <div class="title">Amount (cash):</div>
              <strong>${{ dataSource?.summary?.giftCard?.totalAmtInCash || 0 | AmountPipe }}</strong>
            </li>
          </ul>
        </nb-card-body>
      </nb-card>
    </div>
    <!--    actual cash-->
    <div class="col-12 col-sm-4 col-lg-3">
      <!--    <app-sell-gift-card></app-sell-gift-card>-->
      <nb-card accent="success" class="actually-cash-card">
        <nb-card-header>Actual cash</nb-card-header>
        <nb-card-body>
          <div class="container">
            Actual cash amt in the cash drawer: <strong>${{ dataSource?.actuallyCash || 0 | AmountPipe }}</strong>
            <div class="text-center">
              <button nbButton size="small" status="success" (click)="onActuallyCashUpdate()">Update</button>
            </div>
            <p *ngIf="dataSource?.actuallyCashHistories?.length">
              (Last updated at
              {{ dataSource.actuallyCashHistories.slice(-1)[0]?.updatedAt | date: 'yyyy-MM-dd HH:mm' }} by
              {{ dataSource.actuallyCashHistories.slice(-1)[0]?.operator?.firstName }})
            </p>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
    <!--    note-->
    <div class="col-12 col-sm-4 col-lg-3">
      <nb-card accent="warning" class="actually-cash-card note-card">
        <nb-card-header>Note</nb-card-header>
        <nb-card-body>
          <div class="container">
            <pre>{{ dataSource?.note }}</pre>
            <div class="text-center">
              <button nbButton size="small" status="warning" (click)="onNoteUpdate()">Update</button>
            </div>
            <p *ngIf="dataSource?.noteHistories?.length">
              (Last updated at
              {{ dataSource.noteHistories.slice(-1)[0]?.updatedAt | date: 'yyyy-MM-dd HH:mm' }} by
              {{ dataSource.noteHistories.slice(-1)[0]?.operator?.firstName }})
            </p>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
</div>
